import React, { useEffect, useState } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'
import OrderScopeFilter, { readScope, writeScope } from '../OrderScopeFilter';

// One component serves six widget ids, but only the ones whose endpoint honours
// ?scope get the filter - showing it where the backend ignores it would be a
// control that silently does nothing.
const OrderListWidget = ({widget, scopeFilter = false}) => {
  const [orders, setOrders] = useState([]);
  const [title, setTitle] = useState('');
  const [scope, setScope] = useState(() => readScope(widget.widgetId));

  useEffect(() => {
    // Scoped to this run, not a shared ref: toggling the scope twice quickly
    // leaves the first request in flight, and a shared "mounted" flag is true
    // again by the time it resolves, so the stale list would overwrite the new
    // one. This flag stays false for the abandoned run.
    let current = true;

    const url = scopeFilter
      ? `coordinatordashboard/${widget.widgetId}?scope=${scope}`
      : `coordinatordashboard/${widget.widgetId}`;

    fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (current) {
        setOrders(data.data.orders);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      current = false;
    };
  }, [scope])

  const changeScope = (next) => {
    writeScope(widget.widgetId, next);
    setScope(next);
  };

  const getDeadline = (order) => {
    const value = new Date(order["deadline"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const orderDetails = (uid) => {
    reactHistory.push(`/orders/${uid}`)
  };

  const getDeadlineStatus = (order) => {
    const diff = order['deadline'] - Math.floor(Date.now() / 1000);
    if(diff > 86400) {
      return <i className="block rounded-full w-2 h-2 bg-green-500" title="Deadline is not within the next 24 hours"></i>
    } else if (diff > 0) {
      return <i className="block rounded-full w-2 h-2 bg-yellow-500" title="Deadline is close!"></i>
    } else {
      return <i className="block rounded-full w-2 h-2 bg-red-600" title="Deadline has passed"></i>
    }
  }
  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <div className="bg-white border shadow rounded border-gray-400" id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      {scopeFilter && <OrderScopeFilter value={scope} onChange={changeScope} />}

      <div className="w-full text-xs">
        {orders.map((order) => (
          <div
            key={order.uid}
            className={`hover:bg-gray-200 flex border-b ${order['highlight'] ?? false ? 'bg-yellow-100' : ''}`}
            onClick={() => orderDetails(order['uid'])}
            title={order['comments']}
          >
            <div className="shrink-0 px-4 py-2 w-16">
              {order['deal_id'] ?
                <a
                  href={`https://my.arnsbogroup.com/crm/deal/details/${order['deal_id']}/`}
                  target="_blank"
                  className="mr-1"
                  onClick={(e) => e.stopPropagation()}
                >
                  D{order['deal_id']}
                </a>
                :
                order['uid']
              }
            </div>
            <div className="grow px-4 py-2 cursor-pointer hover:text-primary truncate">
                {order['name']}
            </div>
            <div className="shrink-0 px-4 py-2 flex justify-between items-center space-x-4">
                <span>{getDeadline(order)}</span>
                <span className="w-1 inline-block ml-2 mr-1">
                    {order['comments'] ? <i className="text-yellow-500 fa fa-info"></i> : ''}
                </span>
                <span className="text-xs w-2 inline-block mr-1">
                    {getDeadlineStatus(order)}
                </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

}

export default OrderListWidget;
